import SaveGameModel from "../../model/SaveGameModel";
import SavegameStrategy from "./SavegameStrategy";

export default class LocalStorageSavegameStrategy extends SavegameStrategy {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel 
     */
    constructor(saveGameModel) {
        super(saveGameModel);
    }

    async load() {
        const savegameString = localStorage.getItem(LocalStorageSavegameStrategy.LOCAL_STORAGE_ID);
        if (!savegameString) {
            this._saveGameModel.reset();
            console.log(`[${LocalStorageSavegameStrategy.name}] Save game doesn't exist!`);
            return;
        }

        try {
            await this._saveGameModel.deserialize(savegameString);
            console.log(`[${LocalStorageSavegameStrategy.name}] Save game loaded successfully!`);
        } catch (ex) {
            console.warn(`[${LocalStorageSavegameStrategy.name}] Unable to load save game. Resetting save game.`, ex);
            this._saveGameModel.reset();
        }
    }

    async save() {
        try {
            const savegameString = await this._saveGameModel.serialize();
            localStorage.setItem(LocalStorageSavegameStrategy.LOCAL_STORAGE_ID, savegameString);
            console.log(`[${LocalStorageSavegameStrategy.name}] Save game saved successfully!`);
        } catch (ex) {
            console.warn(`[${LocalStorageSavegameStrategy.name}] Unable to save save game.`, ex);
        }
    }

    async clear() {
        localStorage.removeItem(LocalStorageSavegameStrategy.LOCAL_STORAGE_ID);
        console.log(`[${LocalStorageSavegameStrategy.name}] Save game cleared successfully!`);
    }
}

LocalStorageSavegameStrategy.LOCAL_STORAGE_ID = "dlq_offthemap_savegame";